import React from 'react';
import {connect} from 'react-redux';
import classNames from 'classnames';

import {getIndices} from 'topmeteo/general/selectors';

const Spacer = ({indices}) => (
    <tr className="product-category-spacer">
        <th>{/* product title */}</th>
        {indices.map(({key, current}) => (
            <td key={key} className={classNames({current})} />
        ))}
    </tr>
);

const mapStateToProps = state => ({
    indices: getIndices(state),
});

export default connect(mapStateToProps)(Spacer);
